import React from "react";

function Statistics() {
    return (
        <div className="statistics">
        <h1>Statistics</h1>
        </div>
    );

}
export default Statistics;